goog.provide("shadow.js.shim.module$src$svg$artwork$no_access_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$no_access_svg");
shadow.js.shim.module$src$svg$artwork$no_access_svg = shadow.js.nativeProvides["src/svg/artwork/no-access.svg"] = shadow$bridge("src/svg/artwork/no-access.svg");
module$shadow_js_shim_module$src$svg$artwork$no_access_svg.default = shadow.js.shim.module$src$svg$artwork$no_access_svg;
